import { readExcelFile } from "src/shared/util/functions";
import { FileCustom } from "../interfaces";
import { IActivityValidation } from ".";
import { error } from "console";
import { validateAndConvertFraction } from "src/shared/util/validateFunction";
import { compareStringsAccentInsensitive } from "src/shared/util/compare";


interface IvariableOptionToValidate {
    id: string,
    value: string,
    homologation: string,
    dependence: string,
    mandatoryOptions: string[]
}

interface IvariableToValidate {
    id: string,
    name: string,
    path: string,
    subPath: string,
    validationType: string,
    required: boolean,
    options: IvariableOptionToValidate[],
    homologation?: string[]
    dependence?: string,
    mandatoryOptions?: string[]
}

interface IerrorValidation {
    fileName: string,
    error: string,
    lineNumber: number,
    type: 'error' | 'warning',
    variable?: string,
    originalKey?: string,
    valueWithError: string
}

export interface IerrorResult {
    fileName: string,
    error: string,
    lineNumber: number[],
    type: 'error' | 'warning',
    variable?: string[]
}

export interface errorResults {
    [k: string]: IerrorResult[]
}

export interface IUsers {
    id: string;
    name: string;
}

export interface Squads {
    members: string;
    guestMembers: string[];
    activities: number;
    carts: number;
    includeUserInDB: boolean;
    users: IUsers[]
}

const checkIfValueIsValid = (activity: any, variable: IvariableToValidate, line: number, ListLocation: any[]) => {

    try {

        let keyInExcel = undefined;

        let hasdependence = (variable?.dependence !== undefined && variable?.dependence !== "") && true;

        let key: any = activity[variable.name] !== undefined ? variable?.name : undefined;

        if (key === undefined) {
            key = variable.homologation?.find((homologation) => {
                if (activity[homologation] !== undefined) {
                    keyInExcel = homologation;
                    return true;
                }
            })
        }


        if (key === undefined && variable.validationType !== "hard" && variable.required) {
            const error: IerrorValidation = {
                fileName: 'Excel File',
                error: `Variable ${variable.name} no encontrado`,
                lineNumber: line,
                type: variable?.required ? 'error' : 'warning',
                variable: variable.name,
                originalKey: keyInExcel,
                valueWithError: ""
            }

            return { key: undefined, value: undefined, error, keyInExcel: keyInExcel || key }
        }

        let value: any;

        if (key !== undefined) {
            value = activity[key]
        }

        if (variable.validationType === 'locationList') {
            const location = ListLocation.find((location) => location.name === value?.trim());

            if (location === undefined) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Locacion ${variable.name} no encontrado o valida para ${value}`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key, errorWithLocation: true }
            };

            return { key: variable.name, value: location[variable.id], error: undefined, keyInExcel: keyInExcel || key, locationId: location?.id }
        }

        // standar validation

        if (variable.validationType === 'boolean') {

            value = value?.trim()?.toLowerCase() === 'si' ? 'true' : value?.trim()?.toLowerCase() === 'no' ? 'false' : value

            if (value === undefined || value === null || (value?.trim() !== "true" && value?.trim() !== "false")) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} no es un booleano valido`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            }
        }

        if (variable.validationType === 'date') {
            if (isNaN(Date.parse(value))) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} no es una fecha valida`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            }
        }

        if (variable.validationType === 'string') {
            if (value === undefined || value === null || value === "" && variable.required) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} no puede ser vacio`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            }
        }

        if (variable.validationType === 'fraction') {
            const isFraction = validateAndConvertFraction(value)
            if (isFraction === false) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} no es una fraccion valida,  debe ser un una fraccion estilo A de B o A / B`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            } else {
                value = isFraction
            }
        }

        if (variable.validationType === 'number') {

            let bypass = (value === "" || !value) && variable.required === false

            value = value?.toString()?.replace(',', '.');

            if (isNaN(Number(value)) && !bypass) {
                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} no es un numero valido, debe ser un numero`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            }
        }

        if (variable.validationType === 'list') {

            // let option = variable.options.find(option => option?.value?.toLowerCase() === value?.trim()?.toLowerCase())

            let option = variable.options.find(option =>
                typeof value === "string"
                    ? option?.value?.toLowerCase() === value.trim().toLowerCase()
                    : option?.value?.toLowerCase() === String(value ?? "").trim().toLowerCase()
            )

            if (option === undefined) {

                // console.log({ option, value, variable, valueTrim: value?.trim() })

                const error: IerrorValidation = {
                    fileName: 'Excel File',
                    error: `Valor de la variable ${variable.name} con valor ${value} no es un valor valido`,
                    lineNumber: line,
                    type: variable?.required ? 'error' : 'warning',
                    variable: variable.name,
                    originalKey: keyInExcel || key,
                    valueWithError: value
                }
                return { key, value, error, keyInExcel: keyInExcel || key }
            }
            hasdependence = variable.options.some((option) => option?.dependence !== undefined && option?.dependence !== "" && option?.dependence !== null) && true;

            value = option?.value
        }

        return { key: variable.name, value, error: undefined, keyInExcel: keyInExcel || key, hasdependence }
    } catch (error) {
        console.log({ error, variable })


        return { key: undefined, value: undefined, error: undefined, keyInExcel: undefined, hasdependence: false }
    }

}

const checkDeppendence = (variable: IvariableToValidate, line: number, ListLocation: any[], sortActivity: any) => {

    if (variable.validationType === 'hard') {
        if (variable.path === 'location') {
            const location = ListLocation.find((location) => location.name === sortActivity[variable.dependence || '']);
            if (location) {
                return { key: variable.name, value: location[variable.subPath], error: undefined }
            }
            return { key: variable.name, value: undefined, error: undefined }
        }
    }

    if (variable.validationType === 'list') {

        const dependenceKey = variable.options[0]?.dependence;
        const dependenceValue = sortActivity[dependenceKey];
        const currentValue = sortActivity[variable.name];
        const option = variable.options.find((option) => option.value === currentValue);
        const possibleDeppendence = option?.mandatoryOptions;

        if (Array.isArray(possibleDeppendence) && !possibleDeppendence.includes(dependenceValue)) {
            const error: IerrorValidation = {
                fileName: 'Excel File',
                error: `Valor de la variable ${variable.name} con valor ${currentValue} no es valido si  ${dependenceKey} tiene un valor de ${dependenceValue}`,
                lineNumber: line,
                type: 'error',
                variable: variable.name,
                originalKey: variable.name,
                valueWithError: currentValue
            }
            return { key: variable.name, value: currentValue, error }
        }

    }

    if (variable.dependence && variable.dependence !== "" && variable.dependence !== null) {
        const dependenceKey = variable.dependence;
        const dependenceValue = sortActivity[dependenceKey];
        const currentValue = sortActivity[variable.name];
        const possibleDeppendence = variable.mandatoryOptions
        if (possibleDeppendence?.includes(dependenceValue) && (currentValue === "" || currentValue === undefined)) {

            if (variable.validationType === "number") {

                if (isNaN(Number(currentValue))) {
                    const error: IerrorValidation = {
                        fileName: 'Excel File',
                        error: `Valor de la variable ${variable.name} no es un numero valido, debe ser un numero`,
                        lineNumber: line,
                        type: variable?.required ? 'error' : 'warning',
                        variable: variable.name,
                        valueWithError: currentValue
                    }
                    return { error }
                }
            } else if (variable.validationType === 'boolean') {
                if (currentValue === undefined || currentValue === null || (currentValue?.trim() !== "true" && currentValue?.trim() !== "false")) {
                    const error: IerrorValidation = {
                        fileName: 'Excel File',
                        error: `Valor de la variable ${variable.name} no es un booleano valido`,
                        lineNumber: line,
                        type: variable?.required ? 'error' : 'warning',
                        variable: variable.name,
                        valueWithError: currentValue
                    }
                    return { error }
                }
            } else if (variable.validationType === 'date') {
                if (isNaN(Date.parse(currentValue))) {
                    const error: IerrorValidation = {
                        fileName: 'Excel File',
                        error: `Valor de la variable ${variable.name} no es una fecha valida`,
                        lineNumber: line,
                        type: variable?.required ? 'error' : 'warning',
                        variable: variable.name,
                        valueWithError: currentValue
                    }
                    return { error }
                }
            } else if (variable.validationType === 'string') {
                if (currentValue === undefined || currentValue === null || currentValue === "") {
                    const error: IerrorValidation = {
                        fileName: 'Excel File',
                        error: `Valor de la variable ${variable.name} no puede ser vacio`,
                        lineNumber: line,
                        type: variable?.required ? 'error' : 'warning',
                        variable: variable.name,
                        valueWithError: currentValue
                    }
                    return { error }
                }
            } else if (variable.validationType === 'fraction') {
                const isFraction = validateAndConvertFraction(currentValue)
                if (isFraction === false) {
                    const error: IerrorValidation = {
                        fileName: 'Excel File',
                        error: `Valor de la variable ${variable.name} no es una fraccion valida,  debe ser un una fraccion estilo A de B o A / B`,
                        lineNumber: line,
                        type: variable?.required ? 'error' : 'warning',
                        variable: variable.name,
                        valueWithError: currentValue
                    }
                    return { error }
                }
            }
        }
    }

    return { key: variable.name, value: sortActivity[variable.name], error: undefined }

}

export const ProcessFiles = async (filesExcel: FileCustom[], variablesToValidate: any[], ListLocation: any[], validatingData: IActivityValidation, listOfUsers: any, originalFlowSelected: any) => {

    let sortActivities: any[] = [];

    let totalErrors: IerrorResult[] = [];

    let keyInFilesFound: string[] = []

    const addError = (error: IerrorValidation) => {

        const variableToOmit = ['fileName', "position", "Fecha", "Negocio"]

        if (variableToOmit.includes(error.originalKey || error.variable || "")) {
            return
        }

        const existIndex = totalErrors.findIndex((e) => e.error === error.error && e.fileName === error.fileName && error.type === e.type);

        if (existIndex !== -1) {
            const existLine = totalErrors[existIndex].lineNumber.find((l) => l === error.lineNumber);
            if (existLine === undefined) {
                totalErrors[existIndex].lineNumber.push(error.lineNumber);
            }
            const existVariable = totalErrors[existIndex].variable?.find((v) => v === error.variable);
            if (existVariable === undefined && error.variable !== undefined) {
                totalErrors[existIndex].variable?.push(error.variable);
            }
            const existUniqueKey = totalErrors[existIndex].variable?.find((v) => v === error.originalKey);
            if (existUniqueKey === undefined && error.originalKey !== undefined) {
                totalErrors[existIndex].variable?.push(error.originalKey);
            }
        } else {
            totalErrors.push({
                fileName: error.fileName,
                error: error.error,
                lineNumber: [error.lineNumber],
                variable: error.variable ? [error.variable] : error?.originalKey ? [error?.originalKey] : undefined,
                type: error.type,
            });
        }
    }

    if (validatingData.projectId === undefined || validatingData.projectId === "") {
        const error: IerrorValidation = {
            fileName: 'General Tab',
            error: `Seleccione un Campo`,
            lineNumber: 0,
            type: 'error',
            variable: undefined,
            originalKey: undefined,
            valueWithError: ""
        }
        addError(error)
    }

    if (validatingData.squadNumber === undefined || validatingData.squadNumber === 0) {
        const error: IerrorValidation = {
            fileName: 'General Tab',
            error: `Seleccione el numero de la cuadrilla`,
            lineNumber: 0,
            type: 'error',
            variable: undefined,
            originalKey: undefined,
            valueWithError: ""
        }
        addError(error)
    }

    if (validatingData.executedDate === undefined) {
        const error: IerrorValidation = {
            fileName: 'General Tab',
            error: `Seleccione la fecha de ejecucion`,
            lineNumber: 0,
            type: 'error',
            variable: undefined,
            originalKey: undefined,
            valueWithError: ""
        }
        addError(error)
    }

    const sheet = originalFlowSelected?.excelSheet

    if (filesExcel.length > 0 && sheet !== undefined) {

        const activities = await readExcelFile(filesExcel, sheet, false, originalFlowSelected?.headerRow);

        for (let index = 0; index < activities.length; index++) {
            const act = activities[index];

            const variablesWithDependence: any[] = []

            const sortActivity: any = {}

            // variables Required by Form
            variablesToValidate.forEach((variable) => {
                const { key, value, error, keyInExcel, hasdependence, errorWithLocation, locationId } = checkIfValueIsValid(act, variable, index, ListLocation);

                if (error !== undefined) {
                    addError(error)
                }

                if (key !== undefined) {
                    sortActivity[key] = value
                }

                if (keyInExcel !== undefined) {
                    keyInFilesFound.push(keyInExcel)
                }

                if (hasdependence) {
                    variablesWithDependence.push(variable)
                }

                if (errorWithLocation) {
                    sortActivity['errorWithLocation'] = errorWithLocation
                }

                if (locationId) {
                    sortActivity['locationId'] = locationId
                }
            })

            variablesWithDependence.forEach((variable) => {
                const { key, value, error } = checkDeppendence(variable, index, ListLocation, sortActivity);

                if (error !== undefined) {
                    addError(error)
                } else if (key !== undefined && value !== undefined) {
                    sortActivity[key] = value
                }

            })

            keyInFilesFound = Array.from(new Set(keyInFilesFound));

            // variables in excel not in formValidation
            Object.keys(act).forEach((key) => {


                if (!keyInFilesFound.includes(key)) {
                    // console.log({ key, keyInFilesFound })
                    addError({
                        fileName: 'Excel File',
                        error: `Columna del archivo ${key} no encontrado`,
                        lineNumber: index,
                        type: 'error',
                        variable: undefined,
                        originalKey: key,
                        valueWithError: act[key]
                    })
                }
            })

            sortActivities.push(sortActivity)
        }

    }

    const usersFromActivities: Squads[] = []

    if (sortActivities?.length > 0) {
        const users: string[] = sortActivities?.map((activity) => activity["Ingenieros"])

        const uniqueUsers = Array.from(new Set(users.filter(user => user !== undefined && user !== null && user?.trim() !== "")));

        uniqueUsers.forEach((user) => {

            const cuadrillaMembers = user.split('/').map((m: string) => m?.trim())

            cuadrillaMembers.forEach((member: string) => {

                const existUser = listOfUsers.find((u: any) => compareStringsAccentInsensitive(u.name, member));

                if (!existUser) {
                    addError({
                        fileName: 'Excel File',
                        error: `NE-001 El nombre del usuario ${member} no se encuentra registrado y sera registrado como invitado, por lo cual no le contara la actividad en el desempeño`,
                        lineNumber: 0,
                        type: 'warning',
                        variable: undefined,
                        originalKey: undefined,
                        valueWithError: member
                    })
                }

                const previousAddMember = usersFromActivities.findIndex((u) => u.members === user);

                if (previousAddMember === -1) {
                    const numberOfActivities = sortActivities.filter((activity) => activity["Ingenieros"] === user).length
                    const guestMembers = existUser ? [] : [member]
                    usersFromActivities.push({
                        members: user,
                        guestMembers,
                        activities: numberOfActivities,
                        carts: 0,
                        includeUserInDB: existUser !== undefined,
                        users: existUser ? [{ id: existUser.id, name: existUser.name }] : []
                    })
                } else {
                    if (existUser === undefined) {
                        usersFromActivities[previousAddMember].guestMembers.push(member)
                    } else {
                        usersFromActivities[previousAddMember].includeUserInDB = true
                        usersFromActivities[previousAddMember].users.push({ id: existUser.id, name: existUser.name })
                    }
                }



            })

        })

        if (usersFromActivities?.filter(x => x.includeUserInDB).length === 0) {
            const error: IerrorValidation = {
                fileName: 'Excel File',
                error: `No se encontraron usuarios para las actividades`,
                lineNumber: 0,
                type: 'warning',
                variable: undefined,
                originalKey: undefined,
                valueWithError: ""
            }
            addError(error)
        }
    }

    const errors: errorResults = {}

    totalErrors.forEach((error) => {
        const fileName = error.fileName;
        if (errors[fileName] === undefined) {
            errors[fileName] = [{
                fileName: fileName,
                error: error.error,
                lineNumber: error.lineNumber,
                type: error.type,
                variable: error.variable,
            }]
        } else {
            const exist = errors[fileName]?.find((e) => e.error === error.error);
            if (exist === undefined) {
                errors[fileName].push({
                    fileName: fileName,
                    error: error.error,
                    lineNumber: error.lineNumber,
                    type: error.type,
                    variable: error.variable,
                })
            } else {
                exist.lineNumber.push(...error.lineNumber);
            }
        }
    })

    return { errors, sortActivities, usersFromActivities, totalNumberOfErrors: totalErrors.length }
}